module.exports = __webpack_public_path__ + "static/img/l-1.a7bed95e.png";